if (!window.__citySectionsReadMoreInit) {
  window.__citySectionsReadMoreInit = true;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-read-more-toggle]');
    if (!btn) return;
    var expanded = btn.parentElement.classList.toggle('is-expanded');
    btn.textContent = expanded ? 'Show less' : 'Read more';
    btn.setAttribute('aria-expanded', expanded);
  });
}
